module.exports = __webpack_public_path__ + "portal-bitcoin--3b79919d.png";


//////////////////
// WEBPACK FOOTER
// ./_source/img/namidia/portal-bitcoin.png
// module id = 204
// module chunks = 0